import action from '../constants/accountSettings';

export const setAccountAvatar = (data) => ({
    type: action.CHANGE_ACCOUNT_AVATAR,
    payload: data
});

export const setAccountAvatarDone = () => ({
    type: action.CHANGE_ACCOUNT_AVATAR_DONE,
});